import { Component, EventEmitter, ElementRef, ViewChild, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DataService } from '../../../core/data/data-service';
import { LogoContentService } from '../../../core/routing/services/asset-library/logo-content.service';
import { CreateLogoContentResponse, LogoContent, LogoContentConfiguration, LogoContentViewModel } from '../logo-content/interfaces/logo-content.i';
import { GlobalConstants } from './../../../common/constants/global.constant';
import { CommonService } from '../../../../app/common/services/common.service';
import { Router } from '@angular/router';
import moment from 'moment';
import { Utils } from '../../../common/utils/utils';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { FormFactor } from '../form-factors/interfaces/form-factors.i';

@Component({
  selector: 'iposcen-create-logo-content',
  templateUrl: './create-logo-content.component.html',
  styleUrls: ['./create-logo-content.component.scss']
})
export class CreateLogoContentComponent implements OnInit, OnDestroy {
  @ViewChild('formFactorsModal') formFactorsModal: ElementRef;
  @Input() logoContentDetails: LogoContentViewModel;
  @Input() isNavigated: boolean;
  @Output() readonly goBacktoLogoContent = new EventEmitter<object>();
  @Input() logoPresentPage;
  logoContentgrpForm: FormGroup;
  isPublishedDateInCorrect: boolean;
  isExpiredDateIncorrect: boolean;
  isSubmitted: boolean;
  isFormValid: boolean;
  selectedLogoContentId: string;
  dateTimeValue: string;
  expiryDateTime: string;
  isPublishDateCustomDatepicker: boolean;
  isExpiryDatePicker: boolean;
  selectedLogoContent: LogoContentViewModel;
  currentDetailPage: string;
  createdLogoContentId: string;
  publishDateValues: string;
  customPublishDateResult: string;
  customExpiryDateResult: string;
  ispublishDateNowStatus: boolean;
  editPublishDateInfo: string;
  editexpiryDateInfo: string;
  isPublishExpiryNever: boolean;
  isCustomPublishDateCorrect: boolean;
  isCustomExpiryDateCorrect: boolean;
  logoContentGroupData: LogoContentConfiguration;
  updatedSelectedLogoContent: LogoContentViewModel;
  publishedNamePlaceholderText = AssetLibraryConstants.PUBLISHED_NAME_PLACEHOLDER;
  internalNamePlaceholderText = AssetLibraryConstants.INTERNAL_NAME_PLACEHOLDER;
  globConst = GlobalConstants;
  selectedLogoFormFactors: FormFactor;
  defaultLogoFormFactors: FormFactor = {
    allDevices: true,
    devices: this.globConst.ALL,
    manufacturer: this.globConst.ALL,
    processors: this.globConst.ALL,
    generations: this.globConst.ALL
    };
  isCustomPublishTimeZoneSelected = false;
  isCustomExpiryTimeZoneSelected = false;  
  private ngUnsubscribe = new Subject<boolean>();

  constructor(
    private formBuilder: FormBuilder,
    private logoContentService: LogoContentService,
    private dataService: DataService,
    private router: Router,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.dateTimeValue = '';
    this.expiryDateTime = '';
    this.publishDateValues = '';
    this.isExpiryDatePicker = false;
    this.isExpiredDateIncorrect = false;
    this.isCustomPublishDateCorrect = false;
    this.isCustomExpiryDateCorrect = false;
    this.customPublishDateResult = GlobalConstants.NOW;
    this.customExpiryDateResult = GlobalConstants.NEVER;
    this.dataService.getLogoContent()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((selectedLogoContent: any) => {
        if (selectedLogoContent) {
          this.updatedSelectedLogoContent = selectedLogoContent as unknown as LogoContentViewModel;
          if (selectedLogoContent.configurations.isPublishDateNow) {
            this.isPublishDateCustomDatepicker = false;
            this.editPublishDateInfo = GlobalConstants.NOW;
          } else {
            this.isPublishDateCustomDatepicker = true;
            this.customPublishDateResult = selectedLogoContent.configurations.publishTime;
            this.editPublishDateInfo = selectedLogoContent.configurations.publishTime;
          }
          if (selectedLogoContent.configurations.isPublishExpiryNever) {
            this.isExpiryDatePicker = false;
            this.editexpiryDateInfo = GlobalConstants.NEVER;
          } else {
            this.isExpiryDatePicker = true;
            this.customExpiryDateResult = selectedLogoContent.configurations.expireTime;
            this.editexpiryDateInfo = selectedLogoContent.configurations.expireTime;
          }
          this.logoContentService.buttonName = GlobalConstants.SAVE_CHANGES;
          this.selectedLogoContent = selectedLogoContent;
          this.selectedLogoContentId = selectedLogoContent.id;
          this.selectedLogoFormFactors = selectedLogoContent.configurations?.formFactor ? selectedLogoContent.configurations?.formFactor : this.defaultLogoFormFactors;//IIT2-4652
        } else {
          this.logoContentService.buttonName = GlobalConstants.SAVE_AND_PROCEED;
          this.selectedLogoFormFactors = this.defaultLogoFormFactors;//IIT2-4652
        }
      });
    this.isSubmitted = false;
    this.createLogoContentGroupForm();
    //To get original contengrouppages for normal edit flow
    if (this.selectedLogoContentId) {
      this.logoContentService.getLogoContentById(this.selectedLogoContentId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(getLogoContentById => {
          this.logoContentGroupData = JSON.parse(getLogoContentById.logoContent.configurations) as LogoContentConfiguration;
        },
          error => {
            // do something
          });
    }
    this.commonService.getRetailGifValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data === true) {
          this.commonService.setSwitchstatus(true);
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  createLogoContentGroupForm() {
    // TODO -- need to add validations for form fields
    this.logoContentgrpForm = this.formBuilder.group({
      publishedName: new FormControl((this.selectedLogoContent) ? this.selectedLogoContent.configurations.publishedName : '',
        [Validators.required, Validators.maxLength(50)]),
      publishedTimeStamp: new FormControl((this.selectedLogoContent) ?
        this.selectedLogoContent.configurations.publishTime : GlobalConstants.NOW),
      internalName: new FormControl((this.selectedLogoContent) ?
        this.selectedLogoContent.configurations.internalName : ''),
      expiryTimeStamp: new FormControl((this.selectedLogoContent) ?
        this.selectedLogoContent.configurations.expireTime : GlobalConstants.NEVER)
    });
  }

  getPublishDate(selectedDate: any[]) {
    this.dateTimeValue = `${selectedDate[0]}, ${selectedDate[1]}`;
  }

  getExpiryNever(time: any) {
    this.expiryDateTime = GlobalConstants.NEVER;
  }

  getSelectedTime(time: string) {
    this.dateTimeValue = time;
  }

  getExpirySelectedTime(selectedDate: any[]) {
    let expiryDateSmaller = false;
    const expiryDateVal = selectedDate[0];
    if (this.dateTimeValue.toString() === '') {
      // check if expiry date is smaller than current date
      const today = Utils.getCurrentDate();
      expiryDateSmaller = Date.parse(expiryDateVal) <
        Date.parse(today);
    } else {
      const publishDateValue = this.dateTimeValue[0];
      expiryDateSmaller = Date.parse(expiryDateVal) <
        Date.parse(publishDateValue);
    }
    this.expiryDateTime = `${selectedDate[0]}, ${selectedDate[1]}`;
  }

  createLogoContent() {
    const logoFactor: FormFactor = Utils.getFormFactorValues(this.selectedLogoFormFactors);
    const logoContent: LogoContentConfiguration = {
      publishedName: this.logoContentgrpForm.controls.publishedName.value.trim(),
      internalName: this.logoContentgrpForm.controls.internalName.value,
      publishTime: (this.customPublishDateResult.toString() !== GlobalConstants.NOW) ?
        this.customPublishDateResult.toString() : Utils.getCurrentDate(),
      expireTime: (this.customExpiryDateResult.toString() !== GlobalConstants.NEVER) ?
        this.customExpiryDateResult.toString() : GlobalConstants.NEVER,
      contentScheduleTimezoneCode: 'CST',
      formFactor: logoFactor,
      type: GlobalConstants.LOGO_CONTENT_GROUP,
      contentGroupPages: [],
      isPublishDateNow: !this.isPublishDateCustomDatepicker,
      isPublishExpiryNever: !this.isExpiryDatePicker
    };
    if (logoContent.expireTime !== GlobalConstants.NEVER) {
      logoContent.expireTime = Utils.changeSaveDateFormat(logoContent.expireTime);
    }
    if (!logoContent.isPublishDateNow) {
      logoContent.publishTime = Utils.changeSaveDateFormat(logoContent.publishTime);
    }
    this.logoContentService.createLogoContent(JSON.stringify(logoContent))
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(createLogoContentResponse => {
        const createLogoContentResponseObj: CreateLogoContentResponse = createLogoContentResponse as CreateLogoContentResponse;
        this.goBacktoLogoContent.emit(createLogoContentResponseObj);

        // Coding for create profile logo content
        this.createdLogoContentId = createLogoContentResponse.logoContent.id;
        this.currentDetailPage = this.router.url;
        const pageName = this.currentDetailPage.lastIndexOf('/');
        // checking if Current URL is for create profile
        if (this.currentDetailPage.substring(pageName + 1) === GlobalConstants.CREATE_PROFILE) {
          // using commonservice to pass Logocontet id to create profile page
          this.commonService.emitLogoContentId(this.createdLogoContentId);
        }
      },
        error => {
        }
      );

    // this.goBacktoLogoContent.emit({"logoContent":{"id":"logo-content-d62f99b1-c3c0-476c-84f0-26817bbbffb8","configurations":'{"publishedName":"Newyork sales","internalName":"","publishTime":"2020-12-04","expireTime":"2020-12-04","contentScheduleTimezoneCode":"CST","type":"LogoContentGroup","contentGroupPages":[]}',"islocked":false,"updateTime":"December 03, 2020 13:06:03","createdByUser":"224f3e3a-7d13-4b43-bf0f-d1b39628ed5a","isdefault":false,"ispushedToDevice":false},"responseContext":{"sessionId":"7681F289C961CD10E2D2225963BE13E1","status":"OK","statusCode":200,"success":true,"currentTimeStamp":"2020-12-03T13:06:03.644+00:00"}}); /*sample response */
  }

  updateLogoContent() {
    const logoContent = this.selectedLogoContent as unknown as LogoContent;
    if(logoContent.configurations['previewType'] == undefined || logoContent.configurations['idleExpFullscreenEnabled'] == undefined) {
      logoContent.configurations['previewType'] = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
      logoContent.configurations['idleExpFullscreenEnabled'] = false;
    }
    const logoFactor: FormFactor = Utils.getFormFactorValues(this.selectedLogoFormFactors);
    const logoContentConfig: LogoContentConfiguration = {
      publishedName: this.logoContentgrpForm.controls.publishedName.value.trim(),
      internalName: this.logoContentgrpForm.controls.internalName.value,
      publishTime: (this.customPublishDateResult.toString() !== GlobalConstants.NOW) ?
        this.customPublishDateResult.toString() : Utils.getCurrentDate(),
      expireTime: (this.customExpiryDateResult.toString() !== GlobalConstants.NEVER) ?
        this.customExpiryDateResult.toString() : GlobalConstants.NEVER,
      contentScheduleTimezoneCode: 'CST', // TODO - What timezone to set here
      formFactor: logoFactor,
      type: GlobalConstants.LOGO_CONTENT_GROUP,
      contentGroupPages: this.logoContentGroupData.contentGroupPages,
      isPublishDateNow: !this.isPublishDateCustomDatepicker,
      isPublishExpiryNever: !this.isExpiryDatePicker
    };
    if (logoContentConfig.expireTime !== GlobalConstants.NEVER) {
      logoContentConfig.expireTime = Utils.changeSaveDateFormat(logoContentConfig.expireTime);
    }
    if (!logoContentConfig.isPublishDateNow) {
      logoContentConfig.publishTime = Utils.changeSaveDateFormat(logoContentConfig.publishTime);
    }
    const logoContentConfigObj: LogoContentConfiguration = this.updatedSelectedLogoContent.configurations as LogoContentConfiguration;
    logoContent.configurations = JSON.stringify(logoContentConfig);
    this.logoContentService.putLogoContentById(JSON.stringify(logoContent), this.selectedLogoContentId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(putLogoContentResponse => {
        if (this.isNavigated) {
          const logoContentResponseObj = { logoContent: putLogoContentResponse.logoContent };
          logoContentResponseObj.logoContent.configurations =
            JSON.parse(logoContentResponseObj.logoContent.configurations) as LogoContentConfiguration;
          logoContentResponseObj.logoContent.configurations.contentGroupPages = logoContentConfigObj.contentGroupPages;
          this.goBacktoLogoContent.emit(logoContentResponseObj);
        } else {
          const createLogoContentResponseObj: CreateLogoContentResponse = putLogoContentResponse as CreateLogoContentResponse;
          this.goBacktoLogoContent.emit(createLogoContentResponseObj);
        }
      },
        error => {
        });
  }

  cancel() {
    this.isSubmitted = false;
    this.goBacktoLogoContent.emit({ cancel: true });
    this.dataService.setLogoContent(undefined);
  }

  // check if published date is smaller than today's date
  checkPublishedDateTime() {
    this.isSubmitted = false;
    const today = new Date();
    let isPublishedDateSmaller: boolean;
    if (this.logoContentgrpForm.controls.publishedTimeStamp.toString() !== '') {
      isPublishedDateSmaller = new Date(this.logoContentgrpForm.controls.publishedTimeStamp.value).getTime() < new Date().getTime();
    }

    this.isPublishedDateInCorrect = isPublishedDateSmaller;
  }

  // check if expiry date is smaller than published date
  checkExpiryDateTime() {
    if (this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = Utils.customDateCheck(this.customPublishDateResult, this.customExpiryDateResult);
    }
  }
  customValidation() {
    if (this.isPublishDateCustomDatepicker) {
      this.isCustomPublishDateCorrect = (this.customPublishDateResult === GlobalConstants.NOW);
    }
    if (this.isExpiryDatePicker) {
      this.isCustomExpiryDateCorrect = (this.customExpiryDateResult === GlobalConstants.NEVER);
    }
  }

  onAdd() {
    this.isSubmitted = true;
    this.checkExpiryDateTime();
    this.customValidation();
    this.isFormValid = !this.isPublishedDateInCorrect &&
      !this.isExpiredDateIncorrect &&
      !this.isCustomExpiryDateCorrect &&
      !this.isCustomPublishDateCorrect &&
      this.logoContentgrpForm?.controls?.publishedName?.value.trim() !== ''
      && !this.logoContentgrpForm?.controls?.publishedName?.errors?.maxlength &&
      !this.isCustomPublishTimeZoneSelected && !this.isCustomExpiryTimeZoneSelected;
    if (this.isFormValid) {
      // if (this.logoContentDetails && this.logoContentDetails.id) {
      if (this.selectedLogoContentId) {
        // edit api
        this.updateLogoContent();
      } else {
        this.createLogoContent();
      }
    }
  }

  selectCustomPublishDate(datetimeOption) {
    this.isPublishDateCustomDatepicker = this.checkStatus(datetimeOption);
    if (!this.isPublishDateCustomDatepicker && this.customPublishDateResult !== GlobalConstants.NOW) {
      this.customPublishDateResult = Utils.getCurrentDate();
    }
    if (datetimeOption === GlobalConstants.NOW) {
      this.isCustomPublishDateCorrect = false;
      this.isCustomPublishTimeZoneSelected = false;
    }
  }

  selectExpiryDateTimeZone(datetimeOption) {
    this.isExpiryDatePicker = this.checkStatus(datetimeOption);
    if(this.isExpiryDatePicker && this.editexpiryDateInfo) {
      this.customExpiryDateResult = this.editexpiryDateInfo;
    }
    if (!this.isExpiryDatePicker && this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.customExpiryDateResult = GlobalConstants.NEVER;
    }
    if (datetimeOption === GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = false;
      this.isCustomExpiryDateCorrect = false;
      this.isCustomExpiryTimeZoneSelected = false;
    }
  }

  checkStatus(status) {
    return (status === GlobalConstants.CUSTOM);
  }

  getLogoContentPublishDate(data) {
    this.customPublishDateResult = this.generateDateTimeZone(data);
  }

  getLogoContentExpiryDate(data) {
    this.customExpiryDateResult = this.generateDateTimeZone(data);
  }

  generateDateTimeZone(data) {
    return `${moment(data.dateVal).format(GlobalConstants.DATE_FORMAT)} ${data.hour}:${data.min} ${data.timeZone}`;
  }
  checkIfTimeset(data, check) {
    if (check === 'publish') {
      if (data[0] && data[1]) {
        this.isCustomPublishDateCorrect = false;
      }
    } else {
      if (data[0] && data[1]) {
        this.isCustomExpiryDateCorrect = false;
      }
    }
  }

  openLogoFormModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  openFormFactorsModal() {
    this.openLogoFormModal(this.formFactorsModal);
  }

  applyLogoFormFactor(updatedFormFactors) {
    this.selectedLogoFormFactors = updatedFormFactors;
    this.closeModal(this.formFactorsModal);
  }

  checkTimeZone(data, check) {
    (check === GlobalConstants.PUBLISH) ? (this.isCustomPublishTimeZoneSelected = !data) : (this.isCustomExpiryTimeZoneSelected = !data);
  }
}
